<div
  class="SubscriptionBanner__Alert alert alert-primary d-flex"
  role="alert"
  [ngClass]="{ 'SubscriptionBanner__Alert--Hidden': hideBanner }"
>
  <span
    >The free tier allows for managing only one property at a time. <br />
    <a routerLink="/home/subscribe">Upgrade</a>
    to one of professional plans to add more properties.
  </span>
  <button
    type="button"
    class="close"
    (click)="closeBannerMessage()"
    data-dismiss="alert"
    aria-label="Close Alert"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
